export default __webpack_public_path__ + "media/onboarding/sending-e0232296.gif";